module.exports = __webpack_public_path__ + "img/square.33526d7e.svg";